import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppActions, AppApiActions } from "./app.actions";
import { catchError, filter, map, switchMap, take } from "rxjs/operators";
import { ProjectService } from "../Modules/Projects/project.service";
import { EMPTY, of } from "rxjs";
import { OAuthService } from "../shared/services/oauth.service";


@Injectable()
export class AppEffects {

  ngrxOnInitEffects() {
    return AppActions.loadSelectableProjects();
  }

  loadSelectorProjects$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppActions.loadSelectableProjects),
      // Wait for the user to be confirmed logged in before making the HTTP call.
      // Using switchMap + filter+take(1) on the ReplaySubject means:
      //   - Already logged in → resolves synchronously (ReplaySubject replays last value)
      //   - Not yet logged in → waits without emitting a failure action
      //   - Multiple rapid dispatches → switchMap cancels the previous, only latest wins
      switchMap(() =>
        this.authService.loginChanged.pipe(
          filter(Boolean),
          take(1),
          switchMap(() =>
            this.projectService.getSelectorProjects().pipe(
              map(selectableProjects => AppApiActions.loadSelectableProjectsSuccess({ selectableProjects })),
              catchError(error => of(AppApiActions.loadSelectableProjectsFailure({ errorMessage: error })))
            )
          )
        )
      )
    );
  });

  loadProjectSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.setCurrentProject),
      switchMap(({ currentProjectId }) =>
        this.projectService.getProjectSettings(currentProjectId).pipe(
          map(settings => AppApiActions.loadProjectSettingsSuccess({ settings })),
          catchError(() => EMPTY)
        )
      )
    )
  );

  constructor(private actions$: Actions, private projectService: ProjectService, private authService: OAuthService) { }
}
